<div class="terms_and_condition container">
    <div class="terms_and_condition_body  mtop-10 p-10 col-md-8 col-sm-12  "
        [ngClass]="{'border col-lg-7 col-md-10': showTermsAndCondition}">
        <!-- terms condition_content -->
        <div class="terms_and_condition_main_content" *ngIf="showTermsAndCondition">
            <div class="header">
                <div class="terms_condition color-blue fb-68" [ngClass]="{'fs-23': termsAndConditionMessage?.isMobileView}" >
                    {{'terms-and-condition.Accept Terms And Conditions'|translate|translateKey |titleCase}}</div>
                <div class="fbo_id bold " [ngClass]="{'fs-23': termsAndConditionMessage?.isMobileView}"> {{distributorId | distributorIdFormat}}</div>
            </div>


            <div class="terms_and_condition_content mt-15 pl-10" [ngClass]="{'fs-23': termsAndConditionMessage?.isMobileView}">
                <div class="content_1">
                    {{'terms-and-condition.Please click the terms and condition link below to review the FLP Shared Retail Subscription Terms and Conditions. Then check the box and click the SUBMIT button to accept the Terms and Conditions.'|translate }}
                </div>

                <div class="content_4 pl-20">
                    <input tabindex="0" type="checkbox" (change)="acceptTermsandCondition($event)"
                        [checked]="isTermsAndConditionAccepted">
                    <label [ngClass]="{'fs-23': termsAndConditionMessage?.isMobileView}">
                        &nbsp;{{ 'terms-and-condition.I accept the'|translate|translateKey }}
                        <a
                            id="termsAndConditionLink">{{'terms-and-condition.terms and conditions'|translate|translateKey}}</a>
                    </label>
                </div>
            </div>


            <div class="terms_and_condition mt-15">
                <button class="btn btn-large blue-button" [ngClass]="{'fs-23': termsAndConditionMessage?.isMobileView}"  tabindex="0" (click)="submitTermsandCondtion()" type="submit" 
                    [disabled]="!isTermsAndConditionAccepted">
                    {{'terms-and-condition.SUBMIT' |translate |translateKey}}
                </button>

            </div>

        </div>

        <div class="terms_and_condition_messages" *ngIf="(!showTermsAndCondition && termsAndConditionMessage?.msg)">

            <div class="image text-center mb-25">
                <a class="" >
                    <img [imgSrc]="'/images/flpi-logo.jpg'" class="terms_and_condition_image"
                        alt="Forever Living Logo" />
                </a>
            </div>

            <div class=" alert-{{termsAndConditionMessage?.class}} alert-white rounded alertbox  p-10" role="alert"
                *ngIf="(!showTermsAndCondition && termsAndConditionMessage?.msg)">
                <div class="icon"><i class="fa fa-{{termsAndConditionMessage?.icon}}"></i></div>
                <div class="messages ml-50 " [ngClass]="{'fs-23': termsAndConditionMessage?.isMobileView}">{{termsAndConditionMessage?.msg}}</div>
            </div>

        </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/terms-and-condition.component.html